import { getAddToWishlistGtm } from '@project/components/gtmUtils';
import { updateWishlistTotal } from '../wishlist/wishlist';

export const ACTIONS = {
    add: 'add',
    remove: 'remove',
};

/**
 * Updates the wishlist button layout given an action.
 * @param {string} action One of ACTIONS.add or ACTIONS.remove
 */
export function updateWishlistButtonLayout($el, action, pid) {
    if (!pid) return;
    const $pidHeart = $(`[data-pid="${pid}"].add-to-wishlist`);
    const $mergedEl = $el.hasClass('add-to-wishlist') ? $pidHeart : $pidHeart.add($el);
    $mergedEl.toggleClass('state-selected', action === ACTIONS.add);
    $mergedEl.data('wishlist-action', action === ACTIONS.add ? ACTIONS.remove : ACTIONS.add);
}

export default class WishlistHeart {
    init() {
        this.addToWishlist();
    }

    addToWishlist() {
        $('body').on('click', '.add-to-wishlist', (e) => {
            e.preventDefault();
            const $link = $(e.currentTarget);
            const action = $link.data('wishlist-action');
            const url = action === ACTIONS.add
                ? $link.data('add-url')
                : $link.data('remove-url');
            const method = action === ACTIONS.add
                ? 'post'
                : 'get';
            const pid = $link.data('pid');
            const $target = $(e.target);
            if (!url || !pid) {
                return;
            }

            $.ajax({
                url,
                type: method,
                dataType: 'json',
                data: {
                    pid,
                    optionId: null,
                    optionVal: null,
                },
                success(data) {
                    if (data.success) {
                        updateWishlistButtonLayout($link, action, pid);
                        updateWishlistTotal(data);
                        getAddToWishlistGtm(data);
                        $('body').trigger('product:addToWishlist', { pid, action, $target });
                    }
                },
                complete() {
                    $(document).trigger('wishlist:afterAddToList');
                },
            });
        });
    }
}
